let env: any = process.env.NODE_ENV;
const appEnv = process.env.VUE_APP_ENV;
if (appEnv) env = appEnv;
class urlConfig {
  public readonly httpRequestUrl: string = '';
  public readonly wechatUrl:string = '';
  public apirUrlList:Array<string> = [];//api接口列表，用于随机选择一个
  public fePcUrl:string = "";//前端的页面
  public supervisorUrl:string = "";//督导视角
  public privateDeploy:boolean = false;//是否是私有部署

  constructor(str: string) {
    switch (str) {
      case 'development': {
        this.httpRequestUrl = 'http://jigoulocalapi.ketangpai.com';
        this.apirUrlList = [
        ],
        this.wechatUrl = 'https://testopenapi.webtest.ketangpai.com'
        this.fePcUrl = 'https://pc.webtest.ketangpai.com'
        this.supervisorUrl = 'https://pc.webtest.ketangpai.com'
        this.privateDeploy = false;
        break;
      }
      case 'production': {
        this.httpRequestUrl = 'https://jigouapi.ketangpai.com';
        this.apirUrlList = [
            'https://jigouapi.ketangpai.com',
            'https://jigouapi1.ketangpai.com',
            'https://jigouapi2.ketangpai.com',
            'https://jigouapi3.ketangpai.com',
            'https://jigouapi4.ketangpai.com',
            'https://jigouapi5.ketangpai.com',
            'https://jigouapi6.ketangpai.com',
            'https://jigouapi7.ketangpai.com',
            'https://jigouapi8.ketangpai.com',
            'https://jigouapi9.ketangpai.com',
            'https://jigouapi10.ketangpai.com',
          ],
        this.wechatUrl = ' https://openapiv5.ketangpai.com'
        this.fePcUrl = 'https://www.ketangpai.com'
        this.supervisorUrl = 'https://supervisor.ketangpai.com'
        this.privateDeploy = false;
        break;
      }
      case 'test': {
        this.httpRequestUrl = 'https://jigouapiv5.webtest.ketangpai.com';
        this.apirUrlList = ['https://jigouapiv5.webtest.ketangpai.com'],
        this.wechatUrl = 'https://testopenapi.webtest.ketangpai.com'
        this.fePcUrl = 'https://pc.webtest.ketangpai.com'
        this.supervisorUrl = 'https://pc.webtest.ketangpai.com'
        this.privateDeploy = false;
        break;
      }
      default: {
        throw new Error(`environment error at setting request url at urlConfig.js, now process.env.NODE_ENV is:${env}`);
      }
    }
  }
}

export default new urlConfig(env);
